/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import io from 'socket.io-client';
import React from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { deleteFile, get, remove } from 'helpers/QueryHelper';

import DynamicTable from 'packages/DynamicForm/components/DynamicTable';
import { Button, Popconfirm, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import tableData from './compactTableData';

type Props = {
  entityId: string;
  entityName: string;
  moduleName?: string;
  subModuleName: string;
};

const fetcher = (entityId: string, entityName: string): Promise<any> => {
  const fields = '*';
  const parameters = {
    entityId,
    entityName,
  };
  const sort = 'CreatedDate';

  return get('Attachments', fields, parameters, sort, 'SHARE', 'SACHSO');
};

// SOCKET.IO
const socket = io('https://socket.sachso.edu.vn', {
  secure: true,
  reconnection: true,
  reconnectionDelay: 5000,
  reconnectionAttempts: 20,
  // transports: ['polling'],
});

const CompactFiles = ({ moduleName, subModuleName, entityId, entityName }: Props) => {
  const queryClient = useQueryClient();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const key = React.useMemo(() => [`t_${moduleName}_${subModuleName}_${entityName}`, entityId], []);

  const { data, isLoading, isSuccess } = useQuery(key, () => fetcher(entityId, `t_${moduleName}_${subModuleName}_${entityName}`), {
    enabled: entityId !== undefined,
  });

  const extraColumns = React.useMemo(() => {
    return [
      {
        key: 'action-delete',
        width: '1%',
        sort: false,
        render: (text: string, record: { id: string; fileName: string }, index: number) => {
          return (
            <Popconfirm
              title='Bạn có muốn xóa tập tin này không?'
              onConfirm={async () => {
                // DELETE
                await remove('Attachments', record.id, 'SHARE');
                // DELETE FILENAME IN FOLDERS
                await deleteFile(entityName, entityId, record.fileName, subModuleName, moduleName);
                socket.emit('send', { messageType: 'query', payload: { roomId: `t_SHARE_Attachments_${entityId}`.toUpperCase() } });
                queryClient.invalidateQueries(key);
              }}
              okText='Xác nhận'
              cancelText='Không'
            >
              <Button key='delete-file' shape='circle' type='dashed' size='small' icon={<DeleteOutlined />} danger />
            </Popconfirm>
          );
        },
      },
    ];
  }, [entityId, entityName, key, moduleName, queryClient, subModuleName]);

  React.useEffect(() => {
    socket.on('server-message', (response) => {
      switch (response.messageType) {
        case 'query':
          queryClient.invalidateQueries(key);
          break;
        default:
          break;
      }
    });

    socket.on('connect', () => {
      console.log(`Socket is connected with id: ${socket.id}`);
      // Join room
      socket.emit('send', { messageType: 'join-room', payload: { roomId: `t_SHARE_Attachments_${entityId}`.toUpperCase() } });
    });

    socket.on('disconnect', () => {
      console.log('Socket is disconnected');
    });

    // return () => {
    //   socket.disconnect();
    // };
  }, [entityId, queryClient]);

  return <React.Fragment>{isSuccess && <DynamicTable loading={isLoading} dataSource={data} initialTableData={tableData} extraColumns={extraColumns} onReload={undefined} pagination={undefined} />}</React.Fragment>;
};

CompactFiles.defaultProps = {
  moduleName: 'SACHSO',
};

export default CompactFiles;
